import ApiService from './ApiService'
const importsResourceUrl = `${ApiService.prefix}rest/data/importsStatus`
export default {
  getUrl() {
    return importsResourceUrl
  },
  getData() {
    return ApiService.get(`${importsResourceUrl}/status`)
  },
  getHistory(importId) {
    return ApiService.get(`${importsResourceUrl}/history/${importId}`)
  },
  getLogUrl(importId) {
    return `${importsResourceUrl}/recentLog/${importId}`
  },
}